import { erc20Abi } from 'viem'
import { useWriteContract } from 'wagmi'

import { useWaitForTransaction } from '@src/hooks/useWaitForTransaction'

export const useApproveToken = () => {
    const { writeContractAsync } = useWriteContract()
    const { waitForTransactionReceipt } = useWaitForTransaction()

    const approveToken = async (address?: string, spender?: string, amount?: bigint) => {
        if (!address || !spender || !amount) {
            throw new Error('Address, spender, and amount are required')
        }

        return await writeContractAsync({
            abi: erc20Abi,
            address: address as `0x${string}`,
            functionName: 'approve',
            args: [spender as `0x${string}`, amount],
        })
    }

    const waitForApproval = async (hash: string, chainId?: number) => {
        // Pass the chainId parameter to waitForTransactionReceipt
        await waitForTransactionReceipt(hash, false, false, chainId)
    }

    return { approveToken, waitForApproval }
}
